<template>
    <div class="article-info">
        <div class="tougao-top">
            <img class="tougao-img f-inlineblock-top" :src="getTaskCover(task)">
            <div class="tougao-con f-inlineblock-top">
                <p class="tougao-tit f-hide-col-1">{{task.title}}</p>
                <p class="tougao-name f-hide-col-1">游戏：<span class="tougao-name-con f-hide-col-1">{{task.game_name}}</span></p>
                <p class="tougao-name f-hide-col-1">推广官方渠道：<span class="tougao-name-con f-hide-col-1" :title="task.channels.join(' , ')">{{task.channels.join(' , ')}}</span></p>
                <p class="tougao-name f-hide-col-1">推广分发账号：<span class="tougao-name-con account-pic f-hide-col-1">
                    <img class="channel-logo" v-for="(item,index) of task.medias" :key="index" :src="item.logo" :title="item.name">
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/common/_config_theme.scss';
    .article-info{
        background: #f9f9f9;
        &:after{
            content: '';
            display: table;
        }
    }
    .tougao-top {
        padding: 30px;
        margin-bottom: 30px;
        background: $color-bg;
        border-radius: 2px;
        font-size: 14px;
        .tougao-img {
            height: 80px;
            margin-right: 20px;
        }
        .account-pic{
            margin-right: 10px;
        }
        .tougao-tit {
            font: {
                size: 16px;
                weight: bold;
            }
            color: $color-gray;
        }
        .tougao-name{
            font-size: $middle-font;
            color: #999;
            max-width: 700px;
        }
        .tougao-tit,.tougao-name {
            padding-bottom: 10px;
        }
        .tougao-name-con {
            color: #151515;
        }
        .channel-logo{
            width: 25px;
            height: 25px;
            vertical-align: middle;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
</style>

<script>
import {
    TaskBrief 
} from 'Services/getData';
export default {
    props: ['demandType'],
    data (){
        return{
            taskId: '',
            task: {
                channels: [],
                medias: {}
            }
        }
    },
    created(){
        this.getTaskId();
        this.getDetail();
    },
    methods: {
        getTaskId() {
            this.taskId = this.$route.params.taskId;
        },
        getTaskCover(task) {
            let {
                mission_logo, game_logo 
            } = task;
            if(mission_logo){
                return mission_logo
            }
            return game_logo;
        },
        async getDetail() {
            let res = await TaskBrief({
                missionId: this.taskId, demandType: this.demandType
            });
            if (res.data.code == 0) {
                this.task = res.data.data;
            } else {
                alert('任务不存在')
                this.$router.go(-1);
            }
        }
    }
}
</script>
